import { render, staticRenderFns } from "./HeaderActionProjectButtons.vue?vue&type=template&id=5813651b"
import script from "./HeaderActionProjectButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionProjectButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5813651b')) {
      api.createRecord('5813651b', component.options)
    } else {
      api.reload('5813651b', component.options)
    }
    module.hot.accept("./HeaderActionProjectButtons.vue?vue&type=template&id=5813651b", function () {
      api.rerender('5813651b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderActionProjectButtons.vue"
export default component.exports